module.exports = __webpack_public_path__ + "static/media/preferences.740c5177.png";